// src/hooks/useVehiculeFetcher.tsx
/* Hook encargado de hacer la consulta a la base y 
traer las sucursales de la organizacion

Autor: Benjamín León
Fecha: 2024-08-25
*/
import { useState } from 'react'

import Branch, { BranchDto } from '../interfaces/Branch.ts'
import { customFetch } from '../utils/customFetch.ts'
import { BranchState } from '../enums/DocStates.ts'

import { makeUrlBranchDetail, makeUrlBranches } from './connectionData.tsx'

const useBranchesFetcher = () => {
  const [errorBranches, setErrorBranches] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchBranches = async (id: string, status: BranchState) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlBranches(id, status)
      const data = await customFetch<Branch[]>(apiUrl)
      setErrorBranches(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorBranches(err)
      } else {
        setErrorBranches(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  const fetchBranchDetail = async (id: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlBranchDetail(id)
      const branch = await customFetch<BranchDto>(apiUrl)
      setErrorBranches(null)

      return branch
    } catch (err) {
      // Assert the error as an instance of Error
      const myErr = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorBranches(myErr)

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorBranches, loading, fetchBranches, fetchBranchDetail }
}

export default useBranchesFetcher
